import { render, staticRenderFns } from "./DiscountsView.vue?vue&type=template&id=4b714134"
import script from "./DiscountsView.vue?vue&type=script&lang=js"
export * from "./DiscountsView.vue?vue&type=script&lang=js"
import style0 from "./DiscountsView.vue?vue&type=style&index=0&id=4b714134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports